var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlusAqua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-time-Onboard",
    transform: "translate(-836.000000, -749.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(836.000000, 749.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    fill: "#0EBAC5",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "30 24.5087001 24.0330138 24.5087001 24.0330138 31 22.9531416 31 22.9531416 24.5087001 17 24.5087001 17 23.4626407 22.9531416 23.4626407 22.9531416 17 24.0330138 17 24.0330138 23.4626407 30 23.4626407"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusAqua);
export default __webpack_public_path__ + "static/media/add-plus-aqua.1c938ee52f7c7f5703dd4373f2b7c821.svg";
export { ForwardRef as ReactComponent };